import axios from 'axios';
import { http } from './http.js';

/** Always answers the same (202) whether or not the email has an account. */
export async function requestPasswordReset(email: string): Promise<{ message: string; emailEnabled?: boolean }> {
  const { data } = await http.post<{ success: boolean; message: string; emailEnabled?: boolean }>('/v1/identity/password-reset/request', { email });
  return data;
}

export async function confirmPasswordReset(token: string, password: string): Promise<void> {
  await http.post('/v1/identity/password-reset/confirm', { token, password });
}

export function resetErrorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as { error?: { message?: string } } | undefined;
    return body?.error?.message ?? fallback;
  }
  return fallback;
}
